import { getNamConfig } from './nam_api';

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: process.env.REACT_APP_AUTHORITY,
        redirectUri: process.env.REACT_APP_REDIRECT
    },
    cache: {
        cacheLocation: 'sessionStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: [process.env.REACT_APP_SCOPE]
};

export function getLoginRequest() {
    const { configured, scopes } = getNamConfig();
    // Entra cannot combine .default with explicit API scopes in one request.
    const usesDefaultScope = [...loginRequest.scopes, ...scopes]
        .some(scope => scope?.endsWith('/.default'));
    return configured && !usesDefaultScope
        ? { ...loginRequest, extraScopesToConsent: scopes }
        : { ...loginRequest };
}
